import { SecurityTypeCode } from "@/lib/interfaces and Enums/ENUMSecurityTypeCode";
import { returnTrueIfCellCanBeEdited } from "../../columnHelpers/cellCanBeEdited";

const securityTypesEligibleForDeliveryDateEdit = [
  SecurityTypeCode.BNDO,
  SecurityTypeCode.SWO,
];

/**
 * Delivery date can only be edited on BNDO/SWO legs, on top of the generic status check.
 */
export function isDeliveryDateEditable(
  statusER: any,
  securityType: SecurityTypeCode | undefined,
): boolean {
  if (!securityTypesEligibleForDeliveryDateEdit.includes(securityType as SecurityTypeCode)) {
    return false;
  }
  return returnTrueIfCellCanBeEdited(statusER);
}
